<template>
  <div :class="classList">
    <label v-if="label">{{ label }}</label>
    <label v-if="label === ''" class="no-margin-top"></label>
    <div v-if="description" class="description">{{ description }}</div>
    <div
      class="form-check pl-4"
      v-for="(option, index) in optionList"
      :key="'option' + index"
    >
      <input
        class="form-check-input"
        type="checkbox"
        :value="option"
        :id="'checkbox-' + name + index"
        :checked="listCheckedOption.includes(option)"
        @change="onChangeCheck(option, $event.target.checked)"
      />
      <label class="form-check-label ml-1" :for="'checkbox-' + name + index">
        {{ option }}
      </label>
    </div>
    <p
      class="required-message"
      v-if="listCheckedOption.length === 0 && submitClicked && isRequired"
    >
      This field is required.
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a checkbox group, which includes  checkboxes and its label
Any error of the checkbox group (for example: required field) is showed in this component */
export default {
  name: "CheckboxGroup",
  props: {
    /* Name of the checkbox component, it is used in id of each checkbox, 
    therefore it need to be different between CheckboxGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: {
      type: Array,
      default: () => []
    },
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // List of options for checkbox group (the label of each checkbox)
    optionList: {
      type: Array
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      listCheckedOption: this.value
    };
  },
  // created() {
  //   this.listCheckedOption.push(this.optionList[0]);
  //   this.$emit("input", this.listCheckedOption);
  // },
  methods: {
    onChangeCheck(option, isCheck) {
      if (isCheck) {
        this.listCheckedOption.push(option);
      } else {
        this.listCheckedOption = this.listCheckedOption.filter(
          checkedOption => checkedOption !== option
        );
      }
      this.$emit("input", this.listCheckedOption);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/CheckboxGroup.vue